import { Controller } from "stimulus"
import { Settings } from 'settings.js.erb';

export default class extends Controller {
  static get targets() {
    return ['actNumber', 'otherNumber'];
  } 

  companyOfficeChanged(event) {
    let nextNumbers = $(this.element).data('nextNumbers');
    if (this.hasActNumberTarget && nextNumbers) {
      let nextNumberValue = nextNumbers[$(event.currentTarget).val()];
      if (nextNumberValue) {
        $(this.actNumberTarget).val(nextNumberValue)
      }
    }
    let otherNumbers = $(this.element).data('nextOtherNumbers');
    if (this.hasOtherNumberTarget && otherNumbers) {
      let otherNumberValue = otherNumbers[$(event.currentTarget).val()];
      if (otherNumberValue) {
        $(this.otherNumberTarget).val(otherNumberValue)
      }
    }
  }
  
}
